(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-contacts-sector-san", {
                parent: "entity",
                url: "/lebaniego-contacts-sector-san?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearContactosSectorSan",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-san/lebaniego-contactos-sector-san.html",
                        controller:
                            "LebaniegoYearContactosSectorSanController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("lebaniego-contacts-sector-san.new", {
                parent: "lebaniego-contacts-sector-san",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-san/lebaniego-contactos-sector-san-new.html",
                        controller: "LebaniegoYearContactosSectorSanNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-contacts-sector-san"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-contacts-sector-san",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-contacts-sector-san.edit", {
                parent: "lebaniego-contacts-sector-san",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearContactosSectorSan"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-san/lebaniego-contactos-sector-san-detail.html",
                        controller: "LebaniegoYearContactosSectorSanDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-contacts-sector-san"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearContactosSectorSan",
                        function ($stateParams, LebaniegoYearContactosSectorSan) {
                            return LebaniegoYearContactosSectorSan.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-contacts-sector-san",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            });
    }
})();